import React, { useCallback, useEffect, useRef, useState } from 'react'
import * as XLSX from 'xlsx';
import "../../assets/css/ZoneMaster.css";
import "../../assets/css/global.css";
import { AUTH_CODE, usageAnalyticsHeader, UsageAnalyticsFilter, path_Operation } from "../../constants/constVariables";
import { dateFormat, downloadBulk, downloadData, getPlantValue, postUsageAnalyticsCall } from '../../constants/Utils.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { vinsDispatchHistoryAPI, DispatchSearchApi, getUsageAnalytics } from '../../utils/apiServices';
import Table from "../Table/Table";
import BulkSearchErrorModal from '../FormComponents/BulkSearchErrorModal';
import { CustomTab, Select } from '../../atomicComponents';
import DataNotFound from '../DataNotFound';
// import GridLoadingSpinner from './GridLoadingSpinner/GridLoadingSpinner';
import { APILimit } from '../../constants/constVariables';
import BackButton from '../../clientComponents/BackButton/BackButton';
import Loader from '../Loader';
import BulkSearchModal from '../FormComponents/BulkSearchModal';
import ConfirmationModal from "../FormComponents/ConfirmationModal";
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';

export default function UsageAnalytics() {

    const filterPlantName = getPlantValue();
    const [bulkSearchButton, setBulkSearchButton] = useState(false);
    const [usageList, setUsageList] = useState([]);
    const [offset, setOffset] = useState(0);
    const [count, setCount] = useState(0);
    const countRef = useRef(0);  // for calculating offset
    // const filterRef = useRef(0); // for filter div
    const [hasNext, sethasNext] = useState(false);
    // const [filterVinDispatchStatus, setfilterVinDispatchStatus] = useState("");
    const [currentFilter, setcurrentFilter] = useState("all");
    const [currentSearch, setcurrentSearch] = useState("all");
    const [dataPerPage, setDataPerPage] = useState();
    const [totalData, setTotalData] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    // const [selectCount, setSelectCount] = useState(0);
    const [checkedState, setCheckedState] = useState([]);
    const [checkedStateAll, setCheckedStateAll] = useState(false);
    const [allSelectedRows, setAllSelectedRows] = useState(false);
    const [loader, setLoader] = useState(false);
    const [areaList, setAreaDataList] = useState([]);
    const [usageData, setUsageData] = useState([]);

    const increaseOffset = useCallback(() => {
        setOffset(offset + 1);
    }, [offset]);

    const resetOffset = useCallback(() => {
        setOffset(0)
    }, [offset]);

    const increaseRef = useCallback(() => {
        countRef.current = countRef.current + 1
    }, [countRef]);

    const resetConfigs = () => {
        countRef.current = 0
        resetOffset()
    }
    const fetchVins = async () => {

        const response = await getUsageAnalytics(filterPlantName.value, currentFilter, 1000, offset);
        setCount(response.data.total_count);
        // console.log("ResponseMessage:", response.data.data)
        // var lengthIndex = areaList.length;
        // var data = response.data.data.map(function (obj, index) {
        //     return Object.assign({}, obj, { id: lengthIndex + index +1 });
        // })

        setSelectedRows([...selectedRows, ...new Array(response.data.data.length).fill(false)])
        if (offset !== 0) {
            let temp = [...usageList]
            response.data.data.forEach(element => {
                temp.push(element)
            });
            setUsageList(temp);

        } else {
            setUsageList(response.data.data);
            setUsageData(response.data.data)
        }

        setLoader(true);
        increaseOffset();
        increaseRef();
        sethasNext(response.data['has_next'])
        setDataPerPage(response.data.count);
        // setTotalData(data.length);
        // setSelectedRows([...selectedRows, ...new Array(data.length).fill(false)])
        // setUsageList(data);
        setTotalData(response.data.data.length);
    };


    useEffect(() => { fetchVins(); }, ['']);
    useEffect(() => {
        if (countRef.current === 0) {
            fetchVins();
        }
    }, [offset]);
    useEffect(() => { resetConfigs(); }, [currentFilter, currentSearch]);
    useEffect(() => { fetchVins(); }, [currentFilter, currentSearch]);

    const browserBack = () => {
        navigate("/");
    }
    const navigate = useNavigate();


    const handleFilterValue = (value, ref) => {
        // console.log("value",value.value);
        setcurrentFilter(value.value);
    }
    const updateSetSelectedRows = async (pos, data, ind) => {
        // console.log("pos = ",pos)
        if (pos == "all") {
            // console.log("pos in parent = ", pos, ind, data)
            setAllSelectedRows(!allSelectedRows)
            // console.log("allSelectedRows",allSelectedRows)
            var ab = usageList.map((row, index) => {
                if (ind.includes(index + 1)) {
                    return !allSelectedRows
                }
                return allSelectedRows
            })
            // console.log(" = ", ab)
            setSelectedRows(ab)
        }
        else {
            setSelectedRows(prev => {
                let a = [];
                prev.map((item, index) =>
                    index === pos ? a.push(!item) : a.push(item)
                )
                return [...a];
            });
        }
    }
    // useEffect(() => {
    //     // console.log("allSelectedRows = ", allSelectedRows)
    //     setSelectedRows(new Array(selectedRows.length).fill(allSelectedRows))
    // }, [allSelectedRows])

    const handleCheckbox = (data) => {
        setCheckedStateAll(prev => { return !prev });

    }

    useEffect(() => {
        setCheckedState(prev => {
            return [...new Array(usageList.length).fill(checkedStateAll)];
        });
    }, [checkedStateAll])

    const handleSingleCheckbox = (position, e) => {

        setCheckedState(prev => {
            let a = [];
            if (prev.length === 0) {
                usageList.map((item, index) => index === position ? a.push(true) : a.push(false))
            }
            else {
                prev.map((item, index) =>
                    index === position ? a.push(!item) : a.push(item)
                )
            }
            return [...a];
        });
    };

    return (
        <>
            {
                loader ?
                    <>
                        {/* <Breadcrumb /> */}
                        <div className='breadcrumb'>
                            <BackButton action={"usage analytics"} handleClick={browserBack} />
                        </div>
                        <div className="headerwithcount">
                            <div className='countdiv'>
                                <CustomTab
                                    isSelected={false}
                                    title={"Usage Analytics"}
                                    count={totalData}
                                />
                            </div>

                            <div className="blankdiv">
                                <span className='blankdiv-title mediumFont'>
                                    {""}
                                </span>
                                <div style={{ marginRight: '10px' }}>
                                    <Select title={"usageAnalyticsDropdown"} options={UsageAnalyticsFilter} onChange={handleFilterValue} selectClassName={"dispatch-history-header-dropdown"} />
                                </div>

                            </div>
                        </div>

                        <div className="table-main" style={{ height: window.matchMedia('(max-width:1440px)').matches ? window.innerHeight - 150 : window.innerHeight - 160 }}>
                            <Table
                                columns={[...usageAnalyticsHeader]}
                                defaultColumns={[...usageAnalyticsHeader]}
                                showBulkSearch={false}
                                bulkSearchButton={bulkSearchButton}
                                rowHeight={38}
                                rows={usageList}
                                secondaryActions={[
                                    {
                                        name: "Download CSV",
                                        actionFn: () => downloadData(selectedRows, usageList, "Usage Analytics"),
                                        authOperation: AUTH_CODE?.DOWNLOAD,
                                        shouldEnable: true,
                                        backgroundColor: '#82C1A7',
                                    },
                                ]}
                                setAsnCount={setCount}
                                removeRowSelection={false}
                                pagination={true}
                                infiniteScroll={true}
                                actionButtons
                                hasNext={hasNext}
                                loadMoreData={() => fetchVins()}
                                // onRowSelect={() => onRowSelect()}
                                // onClickPath="/dispatched/vin-details"
                                setTotalData={setTotalData}
                                selectedRows={selectedRows}
                                updateSetSelectedRows={updateSetSelectedRows}
                                // selectCount={selectCount}
                                handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
                                handleCheckbox={(e) => handleCheckbox(e)}

                            />

                        </div>
                    </>
                    :
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Loader />
                    </div>
            }
            <style jsx="true">
                {`
                /* Dont move it to any css file, keep it here only */
                @media only screen and (max-width: 768px) {
                    .navbar{
                        display:none;
                    }  
                    #BACK{
                        display: none;
                    }
                    // .mob-secondary-navbar{
                    //     width: calc(100% - 2rem);
                    //     position: fixed;
                    //     left: 0;
                    //     top: 0;
                    // }
                    .mob-secondary-header{
                        background: #F3F5F9;
                        position: fixed;
                        top: 44px;
                        left: 0;
                        width: calc(100% - 1rem);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.25rem 1rem;
                        font-weight: 600;                        
                        line-height: 19px;
                        color: #707070;
                    } 
                    .mob-secondary-navbar{
                        width: calc(100% - 2rem);
                        top: 0;
                    }
                    .mob-header-heading{
                        display: flex;
                        align-items: center;
                    }
                    .mob-header-heading img{
                        height: 20px;
                        margin-right: 0.5rem;
                    }
                    .dispatch-vin-header{
                        display: none;
                    }
                }
                `}
            </style>
        </>
    )
}